export default __webpack_public_path__ + "static/media/stat.d633931f.svg";